import Service from '@ember/service';

export default class newsletterChangesetService extends Service {}
